<template>
  <AppBar :title="`${owner}/${repo}`">
    <v-btn v-if="newIssue" @click="cancelIssueEntry">cancel</v-btn>
    <v-btn v-else @click="showIssueEntry">new issue</v-btn>
  </AppBar>
  <CreateIssue v-if="newIssue" :owner :repo @created="issueCreated" />
  <template v-else-if="data?.data">
    <IssueFilter
      :issues="data.data"
      @change="(p: IssueListIssuesParams) => (params = p)"
    />
    <IssueList :issues="data.data" :owner :repo />
  </template>
</template>
<script setup lang="ts">
import { useQueryClient } from "@tanstack/vue-query";
import { ref, type Ref, shallowRef } from "vue";
import {
  type IssueListIssuesParams,
  useIssueListIssues,
} from "../../../../gen/forgejo-vue";

const props = defineProps<{
  owner: string;
  repo: string;
}>();

const newIssue = ref(false);

const params: Ref<IssueListIssuesParams> = shallowRef({});

const { data, queryKey } = useIssueListIssues(props.owner, props.repo, params, {
  query: { placeholderData: (prev) => prev },
});

function showIssueEntry() {
  newIssue.value = true;
}
function cancelIssueEntry() {
  newIssue.value = false;
}
const queryClient = useQueryClient();
async function issueCreated() {
  newIssue.value = false;
  await queryClient.invalidateQueries({ queryKey });
}
</script>
